// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ReinviteCollaboratorMutationVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
}>;


export type ReinviteCollaboratorMutation = { __typename?: 'Mutation', reInviteTenantUser: { __typename?: 'User', id: string } };

export const Operations = {
  Mutation: {
    ReinviteCollaborator: 'ReinviteCollaborator' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const ReinviteCollaboratorDocument = gql`
    mutation ReinviteCollaborator($email: String!) {
  reInviteTenantUser(email: $email) {
    id
  }
}
    `;
export type ReinviteCollaboratorMutationFn = Apollo.MutationFunction<ReinviteCollaboratorMutation, ReinviteCollaboratorMutationVariables>;

/**
 * __useReinviteCollaboratorMutation__
 *
 * To run a mutation, you first call `useReinviteCollaboratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReinviteCollaboratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reinviteCollaboratorMutation, { data, loading, error }] = useReinviteCollaboratorMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useReinviteCollaboratorMutation(baseOptions?: Apollo.MutationHookOptions<ReinviteCollaboratorMutation, ReinviteCollaboratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReinviteCollaboratorMutation, ReinviteCollaboratorMutationVariables>(ReinviteCollaboratorDocument, options);
      }
export type ReinviteCollaboratorMutationHookResult = ReturnType<typeof useReinviteCollaboratorMutation>;
export type ReinviteCollaboratorMutationResult = Apollo.MutationResult<ReinviteCollaboratorMutation>;
export type ReinviteCollaboratorMutationOptions = Apollo.BaseMutationOptions<ReinviteCollaboratorMutation, ReinviteCollaboratorMutationVariables>;